export const FAKE_AWAITING_TIME = 4000;
export const CREATE_PM_POLL_INTERVAL = 1000;
export const CREATE_PM_POLLING_ENABLED_FOR = 35000;
